import { Component, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';

import { Observable } from 'rxjs';
import { distinctUntilChanged, debounceTime, switchMap } from 'rxjs/operators';

import { ContratoService } from '../../../../providers/contrato-service';
import { ContratosGestaoService } from '../../../../providers/contratos-gestao-service';
import { AlertService } from '../../../../providers/alert-service';
import { MenuService } from '../../../../providers/menu-service';
import { ModulosController } from '../../modulos-controller';
import { UsuarioService } from '../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../providers/gestao-pca-service';
import { FileService } from '../../../../providers/file-service';

import { ModalArquivosPage } from "../../../modais/modal-arquivos/modal-arquivos";

import createNumberMask from 'text-mask-addons/dist/createNumberMask'

declare var jsPDF: any;

@Component({
    selector: 'page-relatorio-fisico-financeiro',
    templateUrl: 'relatorio-fisico-financeiro.html',
    providers: [
        ContratosGestaoService
    ]
})
export class RelatorioFisicoFinanceiroPage extends ModulosController {
    listaDados: any = [];
    listaContratos: any = [];
    listaContratosAux: any = [];
    loading: boolean = true;
    idSecaoPagina: string = "143";
    tiposArquivosAceitos: string = "application/xls";
    dadosImportados: any[];
    totalPrevisto: any = 0;
    totalRealizado: any = 0;

    relatorioParaAdicionar: any = {
        nmContrato: '',
        dsCredor: '',
        dsMetas: '',
        dsAtividade: '',
        qtdePrevista: '',
        valorUnPrevisto: '',
        totalPrevisto: '',
        qtdeRealizada: '',
        valorUnRealizado: '',
        totalRealizado: ''
    }
    dataMask = [/[0-3]/, /\d/, '/', /[0-1]/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];

    searchLoading: boolean = true;

    numberMask = createNumberMask({
        prefix: '',
        suffix: '', // This will put the dollar sign at the end, with a space.
        thousandsSeparatorSymbol: '.',
        allowDecimal: false,
        decimalSymbol: ','
    });

    numberMaskTotal = createNumberMask({
        prefix: 'R$ ',
        suffix: '', // This will put the dollar sign at the end, with a space.
        thousandsSeparatorSymbol: '.',
        allowDecimal: true,
        decimalSymbol: ','
    });

    page1: number = 1;

    pagination = {
        TotalItems: 100,
        CurrentPage: 1,
        PageSize: 10,
        TotalPageLinkButtons: 5,
        RowsPerPageOptions: [10]
    };

    typeahead = new EventEmitter<string>();

    objetoEdit: any = null;
    listEdit: any = [];
    codigoModulo: any = 0;
    comboContratos: any = null;
    analise: any = null;

    @ViewChild('inputFileCM')
    inputFileCMVar: ElementRef;

    desabilitarImportacao = true;

    constructor(public navCtrl: NavController,
        public alertService: AlertService,
        public modalCtrl: ModalController,
        public usuarioService: UsuarioService,
        public navParams: NavParams,
        public contratoService: ContratoService,
        public contratosGestaoService: ContratosGestaoService,
        private fileService: FileService,
        public gestaoPcaService: GestaoPcaService,
        private menuService: MenuService) {
        super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);

        this.analise = this.navParams.get('analise');

        if (this.isJurisdicionado) {
            this.codigoModulo = this.navParams.get('analise').idModuloPca;
          }

        this.carregarDados();
        this.setModuloId(14);

        // this.typeahead
            // .pipe(distinctUntilChanged(), debounceTime(200), switchMap(term => this.buscarContratos(term)))
            // .distinctUntilChanged()
            // .debounceTime(200)
            // .switchMap(term => this.buscarContratos(term))
            // .subscribe(items => {
                // this.listaContratos = items;
            // }, (err) => {
               // console.log(err);
                // this.listaContratos = [];
            // });
    }

    carregarDados() {
        
       /* this.contratosGestaoService.obterAnalise(this.idSecaoPagina).subscribe(data => {
            this.listaDados = data;
            this.loading = false;
        }, error => {
            console.log("erro: " + error);
            this.loading = false;
        });*/

        this.desabilitarImportacao = true;

        this.loading = true;
        this.contratosGestaoService.obterAnalisePag(1, this.idSecaoPagina).subscribe(data => {
            this.listaDados = data.analises;
            this.loading = false;
            this.pagination.TotalItems = data.qtdPags;
            this.desabilitarImportacao = this.listaDados.length > 0;
        }, error => {
            console.log("erro: " + error);
            this.loading = false;
        });

        this.searchLoading = true;
        this.contratosGestaoService.obterContratosGestao().subscribe(data => {
            this.listaContratos = data;
            this.searchLoading = false;
        }, error => {
            console.log("erro: " + error);
            this.searchLoading = false;
        });
    }

    buscarContratos(term: string): Observable<any[]> {
        return this.contratosGestaoService.obterContratosGestaoPorNumero(term);
    }

    fileChange(event) {
        this.alertService.mostraModalConfirmacao("Salvar Arquivo", "Arquivo selecionado, confirma importação?", callback => {
            if (callback) {
                this.loading = true;
                this.fileService.cargaAnalises(event, this.idSecaoPagina).subscribe(data => {
                    this.inputFileCMVar.nativeElement.value = "";
                    this.dadosImportados = data;

                    for (let j = 0; j < this.dadosImportados.length; j++) {
                        this.listaDados.push(this.dadosImportados[j]);
                    }

                    this.alertService.mostraAlerta("Importação concluída.","Para efetivar a importação, clique em salvar ou finalizar.");
                    this.loading = false;

                }, error => {
                    this.inputFileCMVar.nativeElement.value = "";
                    this.alertService.mostraAlerta("Houve um erro ao carregar o arquivo.", error.mensagem);
                    this.loading = false;
                });
            } else {
                this.inputFileCMVar.nativeElement.value = "";
              }
        });
    }

    downloadDoModelo() {
        this.fileService.downloadModeloCargaContratoGestao(this.idSecaoPagina);
    }

    adicionarRelatorio() {

        if (this.relatorioParaAdicionar.nmContrato != '' &&
            this.relatorioParaAdicionar.dsMetas != '' &&
            this.relatorioParaAdicionar.dsAtividade != '' &&
            this.relatorioParaAdicionar.qtdePrevista != '' &&
            this.relatorioParaAdicionar.valorUnPrevisto != '' &&
            this.relatorioParaAdicionar.qtdeRealizada != '' &&
            this.relatorioParaAdicionar.valorUnRealizado != '') {

            this.relatorioParaAdicionar.totalPrevisto = this.totalPrevisto;
            this.relatorioParaAdicionar.totalRealizado = this.totalRealizado;

            let relatorioNovo = {
                "id": 0,
                "idModuloAnalise": 0,
                "contratoGestao": {
                    "id": 0,
                    "nmContrato": this.relatorioParaAdicionar.nmContrato,
                    "credor": "",
                    "cpf": "",
                    "cnpj": "",
                    "objeto": "",
                    "dataAssinatura": "",
                    "inicioVigencia": "",
                    "fimVigencia": "",
                    "dataPublicacao": "",
                    "valorInicial": 0,
                    "responsavel": "",
                    "novaDataVigencia": "",
                    "valorAtual": 0,
                    "aditivos": [],
                    "flCertificado": false,
                    "situacao": "",
                    "dtPrazoPublicacao": "",
                    "diasForaDoPrazo": "",
                    "codSituacao": 0,
                    "arquivos": []
                },
                "dsMetas": this.relatorioParaAdicionar.dsMetas,
                "dsAtividade": this.relatorioParaAdicionar.dsAtividade,
                "quantidadePrevista": this.relatorioParaAdicionar.qtdePrevista.toString().replace('.', ''),
                "valorUnitarioPrevisto": this.relatorioParaAdicionar.valorUnPrevisto,
                "totalPrevisto": this.relatorioParaAdicionar.totalPrevisto.toString().replace(',', ''),
                "quantidadeRealizada": this.relatorioParaAdicionar.qtdeRealizada.toString().replace('.', ''),
                "valorUnitarioRealizado": this.relatorioParaAdicionar.valorUnRealizado,
                "totalRealizado": this.relatorioParaAdicionar.totalRealizado.toString().replace(',', ''),
                "recursosRecebidos": 0,
                "restituicoes": 0,
                "transferencias": 0,
                "rendAcumulados": 0,
                "outrasReceitas": 0,
                "despesasPeriodo": 0,
                "despesasFinanceiras": 0,
                "tipoDespesa": "",
                "naturezaDespesa": "",
                "numeroCheque": "",
                "dataEmissao": "",
                "dataPagamento": "",
                "valorDocumento": 0,
                "valorPago": 0,
                "numeroEditalCotacao": "",
                "dataEditalCotacao": "",
                "exercicio": "",
                "valorRetirado": 0,
                "dataRetornoRecurso": "",
                "valorRetorno": 0,
                "valorCorrecao": 0,
                "justificativa": "",
                "destinacaoValor": "",
                "prazoReposicao": "",
                "orgSocial": "",
                "nomePessoa": "",
                "dataAdmissao": "",
                "dataDesligamento": "",
                "funcaoDesenvolvida": "",
                "cpf": "",
                "valorJaneiro": 0,
                "valorFevereiro": 0,
                "valorMarco": 0,
                "valorAbril": 0,
                "valorMaio": 0,
                "valorJunho": 0,
                "valorJulho": 0,
                "valorAgosto": 0,
                "valorSetembro": 0,
                "valorOutubro": 0,
                "valorNovembro": 0,
                "valorDezembro": 0,
                "totalExercicio": 0
            };

            this.contratoService.obterPorNumeroContrato(this.relatorioParaAdicionar.nmContrato).subscribe(data => {
                // let tipoVinculoTemp = this.listaContratosAux.filter((contrato) => this.relatorioParaAdicionar.nmContrato == contrato.nmContrato)[0];
                console.log(data);
                if (data != null) {
                    relatorioNovo.contratoGestao.id = data.id;
                    relatorioNovo.contratoGestao.nmContrato = data.nmContrato;
                    relatorioNovo.contratoGestao.credor = data.credor;
                    relatorioNovo.contratoGestao.cpf = data.cpf;
                    relatorioNovo.contratoGestao.cnpj = data.cnpj;
                    relatorioNovo.contratoGestao.objeto = data.objeto;
                    relatorioNovo.contratoGestao.dataAssinatura = data.dataAssinatura;
                    relatorioNovo.contratoGestao.inicioVigencia = data.inicioVigencia;
                    relatorioNovo.contratoGestao.fimVigencia = data.fimVigencia;
                    relatorioNovo.contratoGestao.dataPublicacao = data.dataPublicacao;
                    relatorioNovo.contratoGestao.valorInicial = data.valorInicial;
                    relatorioNovo.contratoGestao.responsavel = data.responsavel;
                    relatorioNovo.contratoGestao.novaDataVigencia = data.novaDataVigencia;
                    relatorioNovo.contratoGestao.valorAtual = data.valorAtual;
                    relatorioNovo.contratoGestao.aditivos = data.aditivos;
                    relatorioNovo.contratoGestao.flCertificado = data.flCertificado;
                    relatorioNovo.contratoGestao.situacao = data.situacao;
                    relatorioNovo.contratoGestao.dtPrazoPublicacao = data.dtPrazoPublicacao;
                    relatorioNovo.contratoGestao.diasForaDoPrazo = data.diasForaDoPrazo;
                    relatorioNovo.contratoGestao.codSituacao = data.codSituacao;
                    relatorioNovo.contratoGestao.arquivos = data.arquivos;
                }

                if (this.objetoEdit) {
                    let index = this.listaDados.indexOf(this.objetoEdit);
                    this.listaDados.splice(index, 1);

                    this.listEdit.push(this.objetoEdit);
                }

                this.listaDados.push(relatorioNovo);

                this.objetoEdit = null;

                this.relatorioParaAdicionar.nmContrato =
                    this.relatorioParaAdicionar.dsMetas =
                    this.relatorioParaAdicionar.dsAtividade =
                    this.relatorioParaAdicionar.qtdePrevista =
                    this.relatorioParaAdicionar.valorUnPrevisto =
                    this.relatorioParaAdicionar.totalPrevisto =
                    this.relatorioParaAdicionar.qtdeRealizada =
                    this.relatorioParaAdicionar.valorUnRealizado =
                    this.relatorioParaAdicionar.totalRealizado =
                    this.relatorioParaAdicionar.dsCredor = '';

                this.comboContratos = null;

            }, error => {
                console.log("erro: " + error);
                this.searchLoading = false;
            });
        }

    }

    onContratoChange(contrato) {
        if (contrato != null && contrato != undefined) {
            this.relatorioParaAdicionar.nmContrato = contrato.nmContrato;
            this.relatorioParaAdicionar.dsCredor = contrato.dsCredor;
        } else {
            this.relatorioParaAdicionar.nmContrato = '';
            this.relatorioParaAdicionar.dsCredor = '';
        }
    }

    removerRelatorio(item, edit) {

        if (!edit) {
            this.alertService.mostraModalConfirmacao("Remover Item", "Deseja remover o item?", callback => {
                if (callback) {

                    let index = this.listaDados.indexOf(item);
                    this.listaDados.splice(index, 1);

                    if (item.id != 0) {
                        this.deletarRelatorio(item.id, edit);
                    }
                }
            });
        } else {
            // let index = this.listaDados.indexOf(item);
            // this.listaDados.splice(index, 1);

            if (item.id != 0) {
                this.deletarRelatorio(item.id, edit);
            }
        }
    }

    formatarValorNumerico(valor) {
        let valorFormatado = new Intl.NumberFormat('pt-BR',
            {
                style: 'currency',
                currency: 'BRL'
            }).format(valor);

        return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
    }

    voltarParaContratosGestao() {
        this.menuService.redirecionarPagina(this.contratosGestaoService.obterIdPaginaContratosGestao());
    }

    calcularPrevisto() {

        let qtdePrevista;
        let valorUnPrevisto;

        if (this.relatorioParaAdicionar.qtdePrevista == "" || this.relatorioParaAdicionar.qtdePrevista == null || this.relatorioParaAdicionar.qtdePrevista == undefined || isNaN(this.relatorioParaAdicionar.qtdePrevista)) {
            qtdePrevista = 0;
        } else {
            qtdePrevista = this.relatorioParaAdicionar.qtdePrevista;
        }

        if (this.relatorioParaAdicionar.valorUnPrevisto == "" || this.relatorioParaAdicionar.valorUnPrevisto == null || this.relatorioParaAdicionar.valorUnPrevisto == undefined || isNaN(this.relatorioParaAdicionar.valorUnPrevisto)) {
            valorUnPrevisto = 0;
        } else {
            valorUnPrevisto = this.relatorioParaAdicionar.valorUnPrevisto;
        }

        this.totalPrevisto = parseFloat(qtdePrevista.toString().replace('.', '').replace(',','')) * parseFloat(valorUnPrevisto);

        return this.totalPrevisto;
    }

    calcularRealizado() {

        let qtdeRealizada;
        let valorUnRealizado;

        if (this.relatorioParaAdicionar.qtdeRealizada == "" || this.relatorioParaAdicionar.qtdeRealizada == null || this.relatorioParaAdicionar.qtdeRealizada == undefined || isNaN(this.relatorioParaAdicionar.qtdeRealizada)) {
            qtdeRealizada = 0;
        } else {
            qtdeRealizada = this.relatorioParaAdicionar.qtdeRealizada;
        }

        if (this.relatorioParaAdicionar.valorUnRealizado == "" || this.relatorioParaAdicionar.valorUnRealizado == null || this.relatorioParaAdicionar.valorUnRealizado == undefined || isNaN(this.relatorioParaAdicionar.valorUnRealizado)) {
            valorUnRealizado = 0;
        } else {
            valorUnRealizado = this.relatorioParaAdicionar.valorUnRealizado;
        }

        this.totalRealizado = parseFloat(qtdeRealizada.toString().replace('.', '').replace(',','')) * parseFloat(valorUnRealizado);

        return this.totalRealizado;
    }

    salvar() {

        this.listEdit.forEach(item => {
            this.removerRelatorio(item, true);
        });

        this.listEdit = [];

        this.contratosGestaoService.salvarAnalise(this.listaDados, this.idSecaoPagina).subscribe(data => {
            this.alertService.mostraAlerta("", "Salvo com sucesso.");
            this.carregarDados();
        }, error => {
            this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
        })
    }

    deletarRelatorio(idContratoGestao, edit) {
        this.contratosGestaoService.deletarAnalise(idContratoGestao, this.idSecaoPagina).subscribe(data => {
            if (!edit) {
                this.alertService.mostraAlerta("", "Removido com sucesso.");
            }
        }, error => {
            this.alertService.mostraAlerta("Erro ao excluir", "O registro pode estar vinculado a outra análise no sistema.");
            this.carregarDados();
        })
    }

    finalizar() {

        this.listEdit.forEach(item => {
            this.removerRelatorio(item, true);
        });

        this.listEdit = [];

        if (this.listaDados) {
            this.contratosGestaoService.finalizarAnalise(this.listaDados, this.idSecaoPagina).subscribe(data => {
                this.alertService.mostraAlerta("", "Finalizado com sucesso.");
                this.voltarParaContratosGestao();
            }, error => {
                this.alertService.mostraAlerta("", "Ocorreu um erro ao finalizar:" + error);
            });
        }
    }

    truncateText(text) {
        let numberOfWordsToTruncate = 10;

        if (text != undefined) {
            let separatedByWords = text.toString().split(" ");

            if (this.needTruncate(text)) {
                return separatedByWords.slice(0, numberOfWordsToTruncate).join(" ") + " ...";
            }
            else {
                return text;
            }
        }
    }

    needTruncate(text) {
        let separatedByWords = text.toString().split(" ");
        let numberOfWordsToTruncate = 10;

        return separatedByWords.length >= numberOfWordsToTruncate;
    }

    exibirCompleto(text) {
        this.alertService.mostraAlerta('', text);
    }

    editar(item) {
        this.comboContratos = item.contratoGestao.nmContrato;
        this.relatorioParaAdicionar.nmContrato = item.contratoGestao.nmContrato;
        this.relatorioParaAdicionar.dsCredor = item.contratoGestao.credor;
        this.relatorioParaAdicionar.dsMetas = item.dsMetas;
        this.relatorioParaAdicionar.dsAtividade = item.dsAtividade;
        this.relatorioParaAdicionar.qtdePrevista = item.quantidadePrevista;
        this.relatorioParaAdicionar.valorUnPrevisto = item.valorUnitarioPrevisto;
        this.relatorioParaAdicionar.qtdeRealizada = item.quantidadeRealizada;
        this.relatorioParaAdicionar.valorUnRealizado = item.valorUnitarioRealizado;

        this.objetoEdit = item;
    }

    printData() {

        var doc = new jsPDF("l");
        var totalPagesExp = "{total_pages_count_string}";

        var pageContent = function (data) {
            // HEADER
            doc.setFontSize(20);
            doc.setTextColor(40);
            doc.setFontStyle('normal');

            doc.text("Relatório Físico Financeiro", data.settings.margin.left + 15, 22);

            // FOOTER
            var str = "Page " + data.pageCount;
            // Total page number plugin only available in jspdf v1.0+
            if (typeof doc.putTotalPages === 'function') {
                str = str + " of " + totalPagesExp;
            }
            doc.setFontSize(10);
            doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 10);
        };

        var columns = [
            { title: "Nº Contrato SAC/SCC", dataKey: "contrato" },
            { title: "Meta", dataKey: "meta" },
            { title: "Qtde. Prevista", dataKey: "qtdP" },
            { title: "Valor Un. Previsto", dataKey: "valP" },
            { title: "Total Previsto", dataKey: "totP" },
            { title: "Qtde. Realizada", dataKey: "qtdR" },
            { title: "Valor Un. Realizado", dataKey: "valR" },
            { title: "Total Realizado", dataKey: "totR" }
        ];

        let rows = [];

        this.listaDados.forEach(contrato => {

            var item = {
                "contrato": contrato.contratoGestao.nmContrato,
                "meta": contrato.dsMetas,
                "qtdP": this.formatarValorNumerico(contrato.quantidadePrevista),
                "valP": this.formatarValorNumerico(contrato.valorUnitarioPrevisto),
                "totP": this.formatarValorNumerico(contrato.totalPrevisto),
                "qtdR": this.formatarValorNumerico(contrato.quantidadeRealizada),
                "valR": this.formatarValorNumerico(contrato.valorUnitarioRealizado),
                "totR": this.formatarValorNumerico(contrato.totalRealizado)
            };

            rows.push(item);
        });

        doc.autoTable(columns, rows, {
            theme: 'grid',
            addPageContent: pageContent,
            margin: { top: 30 },
            styles: {
                overflow: 'linebreak',
                columnWidth: 'auto',
                fontSize: 8
            },
            columnStyles: {
                desc: { columnWidth: 'auto' }
            }
        });

        // Total page number plugin only available in jspdf v1.0+
        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp);
        }

        doc.save('relatorio_fisico_financeiro.pdf');
    }

    modalEvidencias(item: any) {

        let titulo = "Evidências";

        let modal = this.modalCtrl.create(ModalArquivosPage,
            {
                titulo: titulo,
                IdProcesso: item.contratoGestao.nmContrato,
                idModuloPCA: this.codigoModulo,
                tipoAnalise: 0,
                jurisdicionado: this.isJurisdicionado,
                isCGE: this.isCGE,
                pFlSefaz: 0,
                origemArquivo: "Processo: " + item.contratoGestao.nmContrato,
                tipoEntidadeExercicio: 0,
                tipodocumento: 0,
                analise: this.analise
            });

        modal.present();

    }

    loadPage(Page: number) {
        this.pagination.CurrentPage = Page;
        this.loading = true;
        this.contratosGestaoService.obterAnalisePag(Page, this.idSecaoPagina).subscribe(data => {
          this.listaDados =  data.analises;
          this.loading = false;
          this.pagination.TotalItems = data.qtdPags;
        }, error => {
          console.log("erro: " + error.mensagem);
          this.loading = false;
        });
      }

      deletarTodos(){
        this.alertService.mostraModalConfirmacao("Excluir os registros", "Deseja excluir " + this.pagination.TotalItems + " registro(s)?", callback => {
            if (callback) {
                this.loading = true;
                this.contratosGestaoService.deletarTodos(this.idSecaoPagina).subscribe(data => {
                    this.alertService.mostraAlerta("Exclusão concluída","Todos os registros foram excluídos.");
                    this.carregarDados();
                }, error => {
                    console.log("erro: " + error);
                    this.alertService.mostraAlerta("Erro ao excluir", "Algum registro pode estar vinculado a outra análise no sistema.");
                    this.carregarDados();                   
                });
            }
        });        
      }

      importarDoAnoAnterior() {

        this.alertService.mostraModalConfirmacao("Importar do Ano Anterior", 
            "Recomenda-se realizar a importação dos dados por meio do template de carga em massa."+
            "<br />Deseja continuar a importação dos registros do ano anterior mesmo assim?", 
            callback => {            
                if (callback) {
                    this.loading = true;
                    this.desabilitarImportacao = true;
                    this.contratosGestaoService.carregarAnoAnterior(this.idSecaoPagina).subscribe(data => {
                        this.alertService.mostraAlerta("", data.mensagem);
                        this.carregarDados();
                    }, error => {
                        console.log("erro: " + error.mensagem);
                        this.alertService.mostraAlerta("Erro ao importar", error.mensagem);
                        this.carregarDados();
                    });
                }
            }
        );

    }  
}



// WEBPACK FOOTER //
// ./src/pages/modulos/contratos-gestao/relatorio-fisico-financeiro/relatorio-fisico-financeiro.ts